import { Fragment } from "react";

import { Typography } from "@mui/material";
import classNames from "classnames";
import { Link, useParams } from "react-router-dom";

import { resources } from "../Resources";

export function LeftMenu() {
	const params = useParams();
	const resourceSlug = params.resourceSlug;

	return (
		<div className="left-menu">
			<Typography className="big-text bold">Resources</Typography>
			<div className="spacing-top" />

			{resources.map((resource) => (
				<Fragment key={resource.slug}>
					<Link
						className="no-underline-link"
						to={`/resources/${resource.slug}`}>
						<div
							className={classNames("option-container", {
								selected: resourceSlug === resource.slug,
							})}>
							<Typography className="underline-on-hover normal-text option-title">
								{resource.title}
							</Typography>
						</div>
					</Link>
					<div style={{ height: "4px" }} />
				</Fragment>
			))}
		</div>
	);
}
